import React from 'react';
import { Link } from 'react-router-dom';
import drawing1 from '../../assets/D1 (1).png';
import drawing2 from '../../assets/D1 (2).png';

const Drawing = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="w-full h-[400px] md:h-[300px] flex flex-col justify-center px-6 hero-bg-color">
        <h1 className="text-white text-4xl md:text-5xl font-bold">Drawing</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Drawing
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <div className="overflow-hidden rounded-[32px] bg-white border border-slate-200 shadow-2xl">
          <div className="px-8 py-10 sm:px-12 sm:py-12">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-slate-900">Drawing Gallery</h2>
            
            </div>
            <div className="grid gap-6 lg:grid-cols-2">
              <div className="overflow-hidden rounded-3xl bg-slate-100">
                <img src={drawing1} alt="Drawing 1" className="w-full h-[620px] object-contain" />
              </div>
              <div className="overflow-hidden rounded-3xl bg-slate-100">
                <img src={drawing2} alt="Drawing 2" className="w-full h-[620px] object-contain" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Drawing;
